import JSZip from "jszip";

const ATTR_IDS = { 0x0101021b: "versionCode", 0x0101021c: "versionName", 0x0101020c: "minSdkVersion", 0x01010270: "targetSdkVersion", 0x01010001: "label" };

const readStringPool = (dv, off) => {
  const count = dv.getUint32(off + 8, true);
  const flags = dv.getUint32(off + 16, true);
  const stringsStart = dv.getUint32(off + 20, true);
  const utf8 = (flags & 0x100) !== 0;
  const strings = [];
  for (let i = 0; i < count; i += 1) {
    let p = off + stringsStart + dv.getUint32(off + 28 + i * 4, true);
    if (utf8) {
      p += (dv.getUint8(p) & 0x80) ? 2 : 1;
      let len = dv.getUint8(p);
      if (len & 0x80) { len = ((len & 0x7f) << 8) | dv.getUint8(p + 1); p += 2; } else p += 1;
      strings.push(new TextDecoder("utf-8").decode(new Uint8Array(dv.buffer, dv.byteOffset + p, len)));
    } else {
      let len = dv.getUint16(p, true);
      if (len & 0x8000) { len = ((len & 0x7fff) << 16) | dv.getUint16(p + 2, true); p += 4; } else p += 2;
      let s = "";
      for (let j = 0; j < len; j += 1) s += String.fromCharCode(dv.getUint16(p + j * 2, true));
      strings.push(s);
    }
  }
  return strings;
};

// Parses Android binary XML (AXML) and returns attributes of <manifest>, <uses-sdk> and <application>.
const parseManifest = (buf) => {
  const dv = new DataView(buf);
  let strings = [];
  let resIds = [];
  const out = {};
  let off = dv.getUint16(2, true);
  while (off + 8 <= dv.byteLength) {
    const type = dv.getUint16(off, true);
    const headerSize = dv.getUint16(off + 2, true);
    const size = dv.getUint32(off + 4, true);
    if (!size) break;
    if (type === 0x0001) strings = readStringPool(dv, off);
    else if (type === 0x0180) resIds = Array.from({ length: (size - 8) / 4 }, (_, i) => dv.getUint32(off + 8 + i * 4, true));
    else if (type === 0x0102) {
      const tag = strings[dv.getUint32(off + 20, true)];
      if (["manifest", "uses-sdk", "application"].includes(tag)) {
        const attrStart = dv.getUint16(off + 24, true);
        const attrSize = dv.getUint16(off + 26, true);
        const attrCount = dv.getUint16(off + 28, true);
        for (let a = 0; a < attrCount; a += 1) {
          const p = off + 16 + attrStart + a * attrSize;
          const nameIdx = dv.getUint32(p + 4, true);
          const raw = dv.getUint32(p + 8, true);
          const dataType = dv.getUint8(p + 15);
          const data = dv.getUint32(p + 16, true);
          const name = ATTR_IDS[resIds[nameIdx]] || strings[nameIdx];
          let value = null;
          if (raw !== 0xffffffff) value = strings[raw];
          else if (dataType === 0x10 || dataType === 0x11) value = data;
          else if (dataType === 0x03) value = strings[data];
          if (name && value !== null && !(tag === "application" && name !== "label")) out[tag === "application" ? "label" : name] = value;
        }
      }
    }
    off += size;
  }
  return out;
};

export const readApkInfo = async (file) => {
  const zip = await JSZip.loadAsync(file);
  const entry = zip.file("AndroidManifest.xml");
  if (!entry) throw new Error("AndroidManifest.xml wasn't found inside the APK, so it may not be a valid Android app.");
  const m = parseManifest(await entry.async("arraybuffer"));
  if (!m.package) throw new Error("The APK's manifest couldn't be read (no package name found).");
  return {
    package_name: String(m.package),
    version_name: m.versionName != null ? String(m.versionName) : "",
    version_code: Number.isFinite(Number(m.versionCode)) ? Number(m.versionCode) : null,
    min_sdk: m.minSdkVersion != null ? String(m.minSdkVersion) : "",
    target_sdk: m.targetSdkVersion != null ? String(m.targetSdkVersion) : "",
  };
};
